import { Container } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    root: {
        //textAlign: "center",
        padding: theme.spacing(4),
        marginTop: theme.spacing(4),

        [theme.breakpoints.down("md")]: {
            padding: theme.spacing(2),
            border: "none",
            boxShadow: "none",
            background: "inherit",
        },
    },
}));

export const PageWrapper = (props: {
    children: any;
    className?: any;
    maxWidth?: false | "xs" | "sm" | "md" | "lg" | "xl";
}) => {
    const classes = useStyles();
    const { children, className, ...others } = props;
    const rootClass = className ? clsx(classes.root, className) : classes.root;

    return (
        <Container className={rootClass} maxWidth={props.maxWidth || "lg"} {...others}>
            {children}
        </Container>
    );
};

export default PageWrapper;
